module.exports = __webpack_public_path__ + "img/acc.271dadff.png";